const backgroundImage = {
  name: "background-image",
  path: "/background-image",
  title: "background-image",
  description: "Utilities for controlling an element's background image.",
  value: {
    "background-image": {
      "bg-image-[<value>]": '<value>',
      "bg-gradient-[<value>]": '<value>',
      'bg-none': 'none'
    }
  },
  exampleData: [
    {
      example: {
        code: `
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-64 bg-cover">
</div>
        `
      }
    },
    {
      example: {
        code: `
<div class="bg-gradient-[linear-gradient(to_top,color-cyan-500,color-blue-500)]"></div>
<div class="bg-gradient-[linear-gradient(to_top_right,color-sky-500,color-indigo-500)]"></div>
<div class="bbg-gradient-[linear-gradient(to_right,color-violet-500,color-fuchsia-500)]"></div>
<div class="bg-gradient-[linear-gradient(to_bottom_right,color-purple-500,color-pink-500/50)]"></div>


<div class="bg-gradient-[radial-gradient(color-cyan-500_25%,color-blue-500_50%)]"></div>
<div class="bg-gradient-[radial-gradient(color-sky-500,color-indigo-500,color-violet-500,color-fuchsia-500)]"></div>


<div class="bg-gradient-[conic-gradient(color-blue-500,color-sky-400)]"></div>
<div class="bg-gradient-[conic-gradient(from_90deg,color-blue-500,color-sky-400)]"></div>

        `
      }
    },
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-image-[]</code> syntax to set the background image of an element:
      </p>
      <div class="max-w-lg mx-auto"> 
        <div class="rounded-lg mt-2 bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-64 bg-cover flex items-center justify-center">
        </div>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-gradient-[<value>]</code> syntax to set the background image of an element:
      </p>
      <div class="mx-auto flex flex-col gap-4">
        <p class="-mb-2 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">linear-gradient</p>
        <div class="rounded-lg text-center font-mono text-sm font-medium text-color-white bg-gradient-[linear-gradient(to_top,color-cyan-500,color-blue-500)] p-8">
          bg-gradient-[linear-gradient(to_top,color-cyan-500,color-blue-500)]
        </div>
        <div class="rounded-lg text-center font-mono text-sm font-medium text-color-white
          bg-gradient-[linear-gradient(to_top_right,color-sky-500,color-indigo-500)] p-8">
          bg-gradient-[linear-gradient(to_top_right,color-sky-500,color-indigo-500)]
        </div>
        <div class="rounded-lg text-center font-mono text-sm font-medium text-color-white
          bg-gradient-[linear-gradient(to_right,color-violet-500,color-fuchsia-500)] p-8">
          bg-gradient-[linear-gradient(to_right,color-violet-500,color-fuchsia-500)]
        </div>
        <div class="rounded-lg text-center font-mono text-sm font-medium text-color-white
          bg-gradient-[linear-gradient(to_bottom_right,color-purple-500,color-pink-500/50)] p-8">
          bg-gradient-[linear-gradient(to_bottom_right,color-purple-500,color-pink-500/50)]
        </div>
        <p class="-mb-2 mt-4 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">radial-gradient</p>
          <div class="flex gap-4">
          <div class="rounded-lg text-center font-mono text-sm font-medium text-color-white
            bg-gradient-[radial-gradient(color-cyan-500_25%,color-blue-500_50%)] p-16 rounded-full">
          </div>
          <div class="rounded-lg text-center font-mono text-sm font-medium text-color-white rounded-full
            bg-gradient-[radial-gradient(color-sky-500,color-indigo-500,color-violet-500,color-fuchsia-500)] p-16">
          </div>
        </div>
        <p class="-mb-2 mt-4 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">conic-gradient</p>
        <div class="flex gap-4">
          <div class="rounded-lg size-32 rounded-full text-center font-mono text-sm font-medium text-color-white bg-gradient-[conic-gradient(color-blue-500,color-sky-400)] p-8">
          </div>
          <div class="rounded-lg size-32 rounded-full text-center font-mono text-sm font-medium text-color-white bg-gradient-[conic-gradient(from_90deg,color-blue-500,color-sky-400)] p-8">
          </div>
        </div>
      </div>
      `
    },
  ]
};

export default backgroundImage;

<div className=" -mb-2 p-16 size-32
bg-gradient-[linear-gradient(to_top,color-cyan-500,color-blue-500)]
bg-gradient-[linear-gradient(to_top_right,color-sky-500,color-indigo-500)]
bg-gradient-[linear-gradient(to_right,color-violet-500,color-fuchsia-500)]
bg-gradient-[linear-gradient(to_bottom_right,color-purple-500,color-pink-500/50)]

bg-gradient-[radial-gradient(color-cyan-500_25%,color-blue-500_50%)]
bg-gradient-[radial-gradient(color-sky-500,color-indigo-500,color-violet-500,color-fuchsia-500)]

bg-gradient-[conic-gradient(color-blue-500,color-sky-400)]
bg-gradient-[conic-gradient(from_90deg,color-blue-500,color-sky-400)]

bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] h-48 p-8"></div>